import { createContext } from "react";
import type { EditorBlock } from "../editor.types";

/**
 * Resolves a page's first picture from blocks already in memory. When absent
 * (for example on the public site), cards fetch the picture themselves.
 */
export const PageThumbnails = createContext<
  ((pageId: string) => EditorBlock | null) | null
>(null);

export function firstPicture(blocks: EditorBlock[] | undefined) {
  return (
    blocks
      ?.filter((block) => block.block_type === "picture" && (block.asset_id || (block.content as {sample?:string}).sample))
      .sort(
        (a, b) =>
          Number(Boolean(a.parent_source_block_id)) -
            Number(Boolean(b.parent_source_block_id)) || a.position - b.position,
      )[0] ?? null
  );
}
